// src/components/Peacock.js
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Comments from "./Comments"; // Reusable comments section
import peacock1 from "../images/peacock1.jpeg";
import peacock2 from "../images/peacock2.jpeg";
import "./Peacock.css";

function Peacock() {
  return (
    <div className="peacock-page">
    

      <main className="peacock-content">
        <section className="peacock-hero">
          <h2>Peacocks</h2>
          <p>
            Peacocks are famous for their extravagant tail feathers and vibrant colors.
          </p>
        </section>

        <section className="peacock-images">
          <img src={peacock1} alt="Peacock 1" />
          <img src={peacock2} alt="Peacock 2" />
        </section>

        <section className="peacock-info">
          <h3>Locations</h3>
          <p>
            Peacocks are native to South Asia but can also be found in other parts of
            the world in gardens and zoos.
          </p>
        </section>
      </main>

      {/* MongoDB Connected Comments Section */}
      <Comments
        birdType="peacock"
        apiEndpoint="http://localhost:5000/api/peacock-comments"
      />

     
    </div>
  );
}

export default Peacock;

